import has from "lodash/has"
import get from "lodash/get"
import noop from "lodash/noop"
import { updateClicksDL } from "utils-lib/analytics/dataLayer"
import {
  getAdobeLaunchAttribute,
  getAdobeLaunchClassName,
} from "utils-lib/analytics/launch"
import MUIButton from "../BaseButton/BaseButton"

// eslint-disable-next-line import/prefer-default-export
export const ButtonMUI = ({
  onClick = () => {},
  children = null,
  className = ``,
  analytics_key,
  // I think this is a mistake and should be "analytics_key" instead of "analyticsKey", but leaving it here just in case.
  analyticsKey = ``,
  shouldNotTrackInComponent = false,
  ariaLabel = ``,
  ariaHasPopup = ``,
  isSCA = false,
  scaValues = {},
  setSCAValues = noop,
  elementType = `Button`,
  buttonRef = null,
  component = undefined,
  ...rest
}) => {
  let clickLabel = ``
  if (typeof analytics_key === `string` && analytics_key !== ``) {
    clickLabel = analytics_key
  } else if (typeof children === `string`) {
    clickLabel = children
  } else {
    const child = get(children, `[0]`, ``)
    if (typeof child === `string`) {
      clickLabel = child
    }
  }

  const analyticsClass = getAdobeLaunchClassName({
    disabled: shouldNotTrackInComponent,
    isSCA,
  })

  const handleClick = (e) => {
    if (!shouldNotTrackInComponent) {
      updateClicksDL({
        ui_element: elementType,
        object_name: ``,
        object_content: clickLabel,
      })

      if (isSCA) {
        setSCAValues(scaValues)
      }
    }

    /* Call the onClick handler. */
    onClick(e)
  }

  // I don't think "analyticsKey" is passed in to this component in any of the usages, but I'll leave it here just in case.
  const restProps = { ...rest, analyticsKey }
  // Fixes "React does not recognize the `useMUI` prop on a DOM element" error
  if (restProps.useMUI) delete restProps.useMUI
  // Fixes "React does not recognize the `isExternalLink` prop on a DOM element" error
  if (has(restProps, "isExternalLink")) delete restProps.isExternalLink

  return (
    <MUIButton
      data-testid="ButtonMUI"
      ref={buttonRef}
      variant="contained"
      className={`${analyticsClass} ${className}`}
      onClick={handleClick}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...getAdobeLaunchAttribute({
        disabled: shouldNotTrackInComponent,
        value: clickLabel,
      })}
      aria-label={ariaLabel}
      aria-haspopup={ariaHasPopup}
      component={component}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    >
      {children}
    </MUIButton>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// ButtonMUI.propTypes = {
//   onClick: PropTypes.func,
//   children: PropTypes.node,
//   className: PropTypes.string,
//   analytics_key: PropTypes.string,
//   analyticsKey: PropTypes.string,
//   shouldNotTrackInComponent: PropTypes.bool,
//   ariaLabel: PropTypes.string,
//   ariaHasPopup: PropTypes.string,
//   isSCA: PropTypes.bool,
//   scaValues: PropTypes.object,
//   setSCAValues: PropTypes.func,
//   elementType: PropTypes.string,
//   buttonRef: PropTypes.node,
//   component: PropTypes.node,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// ButtonMUI.defaultProps = {
//   onClick: () => {},
//   className: ``,
//   analyticsKey: ``,
//   shouldNotTrackInComponent: false,
//   ariaLabel: ``,
//   ariaHasPopup: ``,
//   isSCA: false,
//   setSCAValues: noop,
//   scaValues: {},
//   children: null,
//   elementType: `Button`,
//   buttonRef: null,
//   component: undefined,
// }
